import { cloneDeep } from 'lodash'

const sessionCase = sessionStorage.getItem('AB-test-doors-page')

const DOORS_MODULE_ID = 'fc553ee3153e2d350ba910ea'
const isDoorsAbTestRunning = Boolean(sessionCase)

const sortModules = modules => {
  const clonedModules = cloneDeep(modules)
  const module2 = clonedModules[2]
  const module4 = clonedModules[4]

  switch (sessionCase) {
    case 'A':
      return modules

    case 'B':
      clonedModules.splice(4, 1)
      clonedModules.unshift(module4)

      return clonedModules

    case 'C':
      clonedModules.splice(2, 1)
      clonedModules.unshift(module2)

      return clonedModules

    default:
      return modules
  }
}

export const AbTestSortModule = (dataSort, modularContentId, page) => {
  const shouldSort = DOORS_MODULE_ID === modularContentId && isDoorsAbTestRunning && page === 1

  if (shouldSort) {
    return sortModules(dataSort)
  }

  return dataSort
}
